import { render, staticRenderFns } from "./AttachmentPointEdit.vue?vue&type=template&id=157a6b2c&"
import script from "./AttachmentPointEdit.vue?vue&type=script&lang=js&"
export * from "./AttachmentPointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports